import { render, staticRenderFns } from "./ReceiveDelivery.vue?vue&type=template&id=c25984dc&"
import script from "./ReceiveDelivery.vue?vue&type=script&lang=js&"
export * from "./ReceiveDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports